import { defineMessages } from 'react-intl';

export const DetailsStepContent = defineMessages({
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
  notePlaceholder: {
    id: 'app.ServiceInspection.notePlaceholder',
    defaultMessage: 'Je třeba speciálního vybavení! Nachází se ve stísněné šachtě!',
  },
});

export const DetailsStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
